import { Auth } from 'app/scripts/db/auth';
import { monitor } from '@trello/monitor';

const msPoll = 5000;
const msPollIdle = 20000;

export const getPollLength = (pollRequestFailures: number) => {
  const basePollingInternal =
    Auth.isLoggedIn() && monitor.getStatus() === 'active' ? msPoll : msPollIdle;

  return Math.min(
    pollRequestFailures === 0
      ? basePollingInternal
      : basePollingInternal * Math.pow(2, pollRequestFailures),
    60000,
  );
};
